import { t } from "i18next";

export const submit = (values, props) => {
  const { handleHide, selectedElement, setSelectedServices, index } = props;

  delete selectedElement.updatedBy;
  delete selectedElement.updatedAt;
  delete selectedElement.uuid;
  delete selectedElement.folders;
  delete selectedElement.notes;

  const elementToAdd = {
    ...selectedElement,
    ...values,
  }
  
  setSelectedServices((p)=>p.map((el,idx)=>{
    if(index !== idx)  return el;

    return elementToAdd;
    
  }));
  handleHide();
};

export const validate = (values) => {
  const errors = {};

  if (!values.laborHours) {
    errors.laborHours = t('global:fieldRequired');
  }

  if (!values.hourlyRate) {
    errors.hourlyRate = t('global:fieldRequired');
  }

  return errors;
};
